import { RotateCcw } from "lucide-react";
import { useTranslation } from "@/shared/providers/LanguageProvider";
import { inputClass, selectClass } from "../FormField";
import type { HospitalDashboardViewData } from "../../api/mapHospitalDashboard";

type HospitalDashboardInvoiceFiltersProps = {
  companyFilterOptions: HospitalDashboardViewData["companyFilterOptions"];
  search: string;
  company: string;
  dateFrom: string;
  dateTo: string;
  onSearchChange: (value: string) => void;
  onCompanyChange: (value: string) => void;
  onDateFromChange: (value: string) => void;
  onDateToChange: (value: string) => void;
  onReset: () => void;
};

export function HospitalDashboardInvoiceFilters({
  companyFilterOptions,
  search,
  company,
  dateFrom,
  dateTo,
  onSearchChange,
  onCompanyChange,
  onDateFromChange,
  onDateToChange,
  onReset,
}: HospitalDashboardInvoiceFiltersProps) {
  const { t } = useTranslation();
  const labels = t.safecheck.dashboard.hospitalBoard.filters;

  return (
    <div className="theme-card p-5">
      <div className="grid grid-cols-1 gap-4 md:grid-cols-2 xl:grid-cols-[1.4fr_1fr_1fr_1fr_auto] xl:items-end">
        <div>
          <label className="mb-1.5 block text-[11px] font-semibold uppercase tracking-wide text-muted">
            {labels.search}
          </label>
          <input
            type="text"
            value={search}
            onChange={(event) => onSearchChange(event.target.value)}
            placeholder={labels.searchPlaceholder}
            className={inputClass}
          />
        </div>
        <div>
          <label className="mb-1.5 block text-[11px] font-semibold uppercase tracking-wide text-muted">
            {labels.company}
          </label>
          <select value={company} onChange={(event) => onCompanyChange(event.target.value)} className={selectClass}>
            {companyFilterOptions.map((option) => (
              <option key={option.value || "all"} value={option.value}>
                {"labelKey" in option ? labels[option.labelKey] : option.label}
              </option>
            ))}
          </select>
        </div>
        <div>
          <label className="mb-1.5 block text-[11px] font-semibold uppercase tracking-wide text-muted">
            {labels.from}
          </label>
          <input
            type="date"
            value={dateFrom}
            onChange={(event) => onDateFromChange(event.target.value)}
            className={inputClass}
          />
        </div>
        <div>
          <label className="mb-1.5 block text-[11px] font-semibold uppercase tracking-wide text-muted">
            {labels.to}
          </label>
          <input
            type="date"
            value={dateTo}
            onChange={(event) => onDateToChange(event.target.value)}
            className={inputClass}
          />
        </div>
        <button
          type="button"
          onClick={onReset}
          aria-label={labels.reset}
          className="inline-flex h-10 w-10 items-center justify-center rounded-lg border border-border bg-card text-muted-foreground transition-colors hover:bg-accent/20 hover:border-accent"
        >
          <RotateCcw size={16} />
        </button>
      </div>
    </div>
  );
}
